import { BaseFormControlledModal } from "./base_form_controlled_modal";

/**
 * DeleteDialog
 */
type Props = {
  open: boolean,
  saving?: boolean,
  title: string,
  windowTitle?: string,
  buttonTitle?: string,
  onClose: () => void,
  onDelete: () => void,
};

function DeleteDialog({ open,
  saving,
  title,
  windowTitle = 'Excluindo item',
  buttonTitle = "Excluir",
  onClose,
  onDelete }: Props) {
  return (
    <BaseFormControlledModal
      open={open}
      saving={saving ?? false}
      loading={false}
      title={windowTitle}
      cancelButtonLabel="Cancelar"
      confirmButtonLabel={buttonTitle}
      confirmSavingButtonLabel="Excluindo..."
      savingLabel="Excluindo..."
      buttonColor="red"
      onClose={onClose}
      onSubmit={onDelete}>
      <div className="w-full h-[3rem] flex flex-row justify-center items-center text-black dark:text-white text-lg">
        {title}
      </div>
    </BaseFormControlledModal>

  );
}

export default DeleteDialog;